import Vue from 'vue';

export default {
  state: {
    achievementCategoriesList: [],
  },
  mutations: {
    setAchievementCategoriesList(state, data) {
      state.achievementCategoriesList = data.map((category) => {
        const achievements = category.achievements.sort((a, b) => new Date(b.date) - new Date(a.date));
        return { ...category, achievements };
      });
    },
  },
  actions: {
    getAchievementCategoriesList(store) {
      const path = 'achievement-categories?_sort=name:desc';
      return Vue.prototype.$axios.get(path).then((resp) => {
        store.commit('setAchievementCategoriesList', resp.data);
        return resp.data;
      });
    },
  },
};
